import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ptBR } from '@mui/x-date-pickers/locales';
import dayjs from "dayjs";
import 'dayjs/locale/pt-br';

function GenericYearMonthPicker(
  props
) {
  const { label, value, onChange, placeholder, required, error, helperText, variant, ...rest } = props;

  const handleChange = (dayJSdate) => {
    const dateVal = (dayJSdate)
      ? dayJSdate.toDate()
      : null;
    onChange(dateVal);
  }

  return <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br" localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
    <DatePicker
      views={["year", "month"]}
      slotProps={{
        textField: {
          variant: (!!variant)
            ? variant
            : 'outlined',
          size: "small",
          fullWidth: true,
          error: !!error,
          helperText: helperText,
        },
      }}
      InputProps={{
        disableUnderline: true,
      }}
      label={label.concat((required) ? " *" : "")} // DatePicker não contém required
      size="small"
      InputLabelProps={{ shrink: true }}
      format="MM/YYYY"
      value={(value) ? dayjs(value) : null}
      onChange={handleChange}
      placeholder={placeholder}
      {...rest}
    />
  </LocalizationProvider>

}

export default GenericYearMonthPicker;